import swaggerClient from "../remote-client";

export default class DocumentServiceImpl {
  uploadDocument(document) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.postDocument(
          {},
          swaggerClient.buildRequest(document),
          {}
        )
          .then(res => resolve(res))
          .then(error => reject(error));
      });
    });
  }
}
